// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class MoneyTransferResource extends Resource {
    basePath: string = 'billing/money-transfers/';

    objectPath: string = 'billing/money-transfers/{ident}/';

    print(id: string): Promise<Object> {
        return this.client._request(`${this._getObjectPath(id)}print/`, 'PATCH', {});
    }
}
